const FilterIcon = () => {
    return (
        <i className="fa-solid fa-filter"></i>
    );
}

export default FilterIcon;